import { render, staticRenderFns } from "./document-link.vue?vue&type=template&id=f0ad1370&scoped=true&"
import script from "./document-link.vue?vue&type=script&lang=js&"
export * from "./document-link.vue?vue&type=script&lang=js&"
import style0 from "./document-link.vue?vue&type=style&index=0&id=f0ad1370&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ad1370",
  null
  
)

export default component.exports